import React from 'react';
import { connect } from 'react-redux';
import CrudTab from 'react/containers/pages/CrudTab';
import Analytics from 'react/containers/pages/AnalyticsDashboard';


class Dashboard extends CrudTab {

  componentDidMount() {
    if (!this.props.hasAnalytics) {
      this.router = new App.Routers.EnovarBoard();
      this.router.makeForm();
    }
  }

  render(){
    const { tab: { key: liveKey }, active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div className={className}>
        <div id={liveKey} />
        {this.props.hasAnalytics ? <Analytics className={className}/> : ''}
      </div>
    );
  }

}

const mapStateToProps = () => {
  const featureState = Monet.Session.ApplicationLoad.featureStates.filter(obj => obj.name==="GM_ANALYTICS")[0];
  const hasAnalytics = featureState && featureState.enabled;
  return {
    "hasAnalytics":  hasAnalytics
  }
}

export default connect( mapStateToProps )(Dashboard)
